import { RouteStatus } from "@/types/route/route.common";
export const isOrderWithoutRoute = ({ routeId, routeStatus }) => !routeId || routeStatus === RouteStatus.CANCELLED;
/** То же правило для PostgREST `.or()` по `v_orders_list` («Заказы без маршрутов»). */
export const ORDERS_WITHOUT_ROUTE_FILTER = `routeId.is.null,routeStatus.eq.${RouteStatus.CANCELLED}`;
/** Маршрут, в котором заказ сейчас стоит: любой статус, кроме `CANCELLED` (включая `CREATED`). */
export const getActiveRouteInfo = (routeInfo) => routeInfo && !isOrderWithoutRoute({ routeId: routeInfo.routeId, routeStatus: routeInfo.status })
    ? routeInfo
    : undefined;
